import { v5 as uuidv5 } from "uuid";

const UUID_LOCAL_AUDIO_RECORDING_NAMESPACE = "f0657800-7bfc-4646-acb2-37087e8455d2";

export const resolveCapturedAudioId = ({
  audioRecordingId,
}: {
  audioRecordingId: string;
}): string => {
  const upperAudioRecordingId = audioRecordingId.toUpperCase();
  const namespaceSeed = `AUDIO_RECORDING_CAPTURED_AUDIO::${upperAudioRecordingId}`;
  const derivedNamespace = uuidv5(namespaceSeed, UUID_LOCAL_AUDIO_RECORDING_NAMESPACE);
  return uuidv5(audioRecordingId.toUpperCase(), derivedNamespace);
};
